.column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
}

.marginY {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.questionsContainer {
  padding-left: 2px;
  padding-right: 2px;
}

.loadingBox {
  padding-bottom: 1rem;
}

.stickyGrid {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 1rem;
  border-top: 1px solid #e6e6e6;
  background-color: white;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap;
}
